// @ts-ignore
import type * as SchemaTypes from '../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { FaqQuestionFragmentDoc } from './FaqQuestion.fragment.generated';
export const FaqSectionFragmentDoc = gql`
    fragment faqSection on FaqSection {
  title
  questions {
    ...faqQuestion
  }
}
    ${FaqQuestionFragmentDoc}`;